<template>
  <div class="row justify-content-md-center mt-4 blockAudienceStar">
    <div class="col-md-9">
      <h4 class="mb-4 mt-5" style="color: #22252b;">Segments</h4>
        <div class="box-upload-audience mt-5">
          <a href="/audience/segments" class="btn btn-primary btn-audience-start">CREATE SEGMENT</a>
            <h5 style="margin-top: 20px" class="box-title-upload-audience">
              You have no saved segments
            </h5>
            <span class="box-sub-title-upload-audience">Create segments to target subscribers by location, engagement, activity and more.</span>

        </div>
    </div>
  </div>

</template>

<script>
import services from "@/services.js";
export default {
  name: "Segments Start",
  components: {

  },
  props: {

  },
  data() {
    return {


    };
  },
  mounted() {

  },
  methods: {

  },

  computed: {

  }
};
</script>

<style scoped>
.audienceBrowseIcon{
  width: 70px;
  height: 70px;
  background: url(/img/icons/icon_browse.svg);
  background-repeat: no-repeat;
  margin: auto;
  margin-bottom: 10px;
}

.box-upload-audience{
  width: 100%;
  height: 280px;
  border-radius: 2px;
  border: solid 3px #edeff1;
  cursor: pointer;
  text-align: center;
  padding-top: 4%;
  background-color: #edeff1;
}

.box-upload-audience:hover{

}

.btn-audience-start{
  font-size: 14px !important;
  margin-top: 40px !important;
  color: #fff !important;
  text-decoration: none !important;
}

.box-sub-title-upload-audience{
  font-size: 14px;
  color: #818181;
  margin-top: 40px;
  line-height: normal;
}

.box-title-upload-audience{
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.12;
  letter-spacing: 0.25px;
  text-align: center;
  color: #22252b;
  margin-bottom: 5px;
}

p {
  line-height: 1rem;
}

</style>
